import Badge from 'react-bootstrap/Badge'
import Form from 'react-bootstrap/Form'

const TeamSpiritHelp = ({ t }) => {
  const rows = String(t('teamSpiritCalculatorHelp') || '').split('\n')
  const intro = rows[0] || ''
  const anchor = rows.slice(1).join(' ').trim()

  return (
    <div className="mb-3">
      <h2 className="mb-1">{t('teamSpiritCalculator')}</h2>
      <div style={{ color: '#596271', fontSize: '13px', lineHeight: 1.25 }}>
        <div>{intro}</div>
        {anchor ? (
          <div className="d-flex align-items-center gap-1 mt-1">
            <Badge bg="danger">Away</Badge>
            <Form.Check type="checkbox" disabled style={{ margin: 0 }} />
            <span>{anchor}</span>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default TeamSpiritHelp
